<template>
    <span class="bg-gray-700 text-white uppercase text-1xl flex w-full justify-center text-center p-4 sm:rounded-t">Racing Starts In...</span>
    <div class="bg-gray-800 sm:mb-4 p-6 text-white bg-no-repeat items-center justify-center flex transition duration-500 ease-in-out mt-0 border-b border-gray-500 sm:rounded-b">
		<span class="flex w-full justify-center font-bold text-center text-3xl sm:text-5xl text-racing-stars-yellow"><countdown mainColor="#f8ea0f" labelColor="#fff" :showDays="false" :deadline="moment(race.starts_at).format('YYYY-MM-DD HH:mm:ss')" /></span>
    </div>
</template>

<script>
import { ref } from 'vue'
import { Countdown } from 'vue3-flip-countdown';
import moment from 'moment'

export default {
    props: {
        race: Object,
    },
    components: {
        Countdown,
    },
    setup(props) {
        return {
            moment,
        }
    }
}
</script>